import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "search-page-pagination-wrapper" }
const _hoisted_2 = { class: "search-page-pagination-container header" }
const _hoisted_3 = { class: "search-page-pagination-container-area" }
const _hoisted_4 = { class: "total-count" }
const _hoisted_5 = { class: "total-pages hide" }
const _hoisted_6 = { class: "search-page-pagination-container pagination" }
const _hoisted_7 = { class: "search-page-pagination-container-area total-perPage" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value", "selected"]
const _hoisted_10 = {
  key: 0,
  class: "search-page-pagination-container-area page-navigation"
}
const _hoisted_11 = {
  key: 2,
  class: "pagination-dots"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 3,
  class: "pagination-dots"
}

import { computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchPagination',
  setup(__props) {

const searchPageStore = useSearchPageStore();

const pageNumberData = computed(() => {
  return [
    {
      expression: false,
      value: 1,
      selected: currentPageNumber.value === 1,
    },
    {
      expression: currentPageNumber.value - 2 > 1,
      value: currentPageNumber.value - 2,
      selected: currentPageNumber.value === currentPageNumber.value - 2,
    },
    {
      expression: currentPageNumber.value - 1 > 1,
      value: currentPageNumber.value - 1,
      selected: currentPageNumber.value === currentPageNumber.value - 1,
    },
    {
      expression: true,
      value: currentPageNumber.value,
      selected: true,
    },
    {
      expression: currentPageNumber.value + 1 < currentPageTotal.value,
      value: currentPageNumber.value + 1,
      selected: currentPageNumber.value === currentPageNumber.value + 1,
    },
    {
      expression: currentPageNumber.value + 2 < currentPageTotal.value,
      value: currentPageNumber.value + 2,
      selected: currentPageNumber.value === currentPageNumber.value + 2,
    },
  ];
});

const currentPageNumber = computed<number>(
  () => searchPageStore.searchPageState.query.pageNumber
);

const currentPageTotal = computed<number>(
  () => searchPageStore.searchPageState.query.pageTotal
);

const showNextPageArrow = computed<boolean>(
  () =>
    searchPageStore.searchPageState.query.pageNumber <
    searchPageStore.searchPageState.query.pageTotal
);

const showPreviousPageArrow = computed<boolean>(
  () => searchPageStore.searchPageState.query.pageNumber > 1
);

function isPageActive(pageNumber: number) {
  return searchPageStore.searchPageState.query.pageNumber === pageNumber;
}

function handleOnBlur() {
  // set the currently selected
}

function handlePageNumberClick(pageNumber: number) {
  searchPageStore.handlePageNumberClick(pageNumber);
}

function handlePageSizeChange(pageSize: number) {
  // check if the page size would result in only 1 page

  searchPageStore.handlePageSizeChange(pageSize);
}

function paginationNext() {
  searchPageStore.paginationNext();
}

function paginationPrevious() {
  searchPageStore.paginationPrevious();
}

const showPaginationComponent = computed<boolean>(
  () => searchPageStore.searchPageState.query.pageTotal > 1
);

const paginationEnabled = computed<boolean>(
  () => searchPageStore.searchPageState.query.paginationEnabled
);

const totalCountHeader = computed<string>(() => {
  if (searchPageStore.searchPageState.loading) {
    return "";
  }

  return (
    `Found ${searchPageStore.searchPageState.query.totalCount} Result` +
    `${searchPageStore.searchPageState.query.totalCount != 1 ? "s" : ""}`
  );
});

const paginationHeader = computed<string>(() => {
  if (!paginationEnabled.value) {
    return "";
  }
  return `Page ${searchPageStore.searchPageState.query.pageNumber} of
        ${searchPageStore.searchPageState.query.pageTotal}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(totalCountHeader.value), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(paginationHeader.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("select", {
          value: _unref(searchPageStore).searchPageState.query.perPage,
          onBlur: handleOnBlur,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (
            handlePageSizeChange(
              Number(($event.target as HTMLSelectElement).value)
            )
          ))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchPageStore).searchPageState.query
              .perPageOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              value: option,
              key: option,
              selected: option === _unref(searchPageStore).searchPageState.query.perPage
            }, _toDisplayString(option), 9, _hoisted_9))
          }), 128))
        ], 40, _hoisted_8),
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "items per page", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1))
      ]),
      (
          _unref(searchPageStore).searchPageState.query.pageTotal > 1 &&
          showPaginationComponent.value
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (showPreviousPageArrow.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "pagination:number arrow",
                  onClick: paginationPrevious
                }, " < "))
              : _createCommentVNode("", true),
            (currentPageNumber.value > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePageNumberClick(1))),
                  class: _normalizeClass({
            active: isPageActive(1),
          })
                }, " 1 ", 2))
              : _createCommentVNode("", true),
            (currentPageNumber.value > 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "..."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageNumberData.value.filter((item) => item.expression), (item, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                onClick: ($event: any) => (handlePageNumberClick(item.value)),
                class: _normalizeClass({
            active: isPageActive(item.value),
          })
              }, _toDisplayString(item.value), 11, _hoisted_12))
            }), 128)),
            (currentPageNumber.value < currentPageTotal.value - 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " ... "))
              : _createCommentVNode("", true),
            (currentPageTotal.value > 1 && currentPageNumber.value < currentPageTotal.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePageNumberClick(currentPageTotal.value))),
                  class: _normalizeClass({
            active: isPageActive(currentPageTotal.value),
          })
                }, _toDisplayString(currentPageTotal.value), 3))
              : _createCommentVNode("", true),
            (showNextPageArrow.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  class: "pagination:number arrow",
                  onClick: paginationNext
                }, " > "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})